import { ChannelCreateRow, ChannelUpdateRow, ProviderRow, ProviderType, SentRow } from "namirasoft-teams-sender";
import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { TeamsSenderRoutes } from "./TeamsSenderRoutes";
import { ProductUUID } from "namirasoft-api-product";
import { TeamsSenderMenus } from "./TeamsSenderMenus";
import { TeamsSenderRouterProps } from "./TeamsSenderRouterProps";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, IntegerFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class TeamsSenderEntities
{
	static provider(props: NSARouterMakerResult & TeamsSenderRouterProps): IEntityInfo<ProviderRow, ProviderRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_TEAMS_SENDER,
			name: "provider",
			tables: [{ table: namirasoft.teams_sender.tables.provider, required: true }],
			client: {
				getListURL: () => TeamsSenderRoutes.ProviderList,
				getNewURL: () => TeamsSenderRoutes.ProviderNew,
				getCopyURL: (id: string) => TeamsSenderRoutes.ProviderCopy(id),
				getEditURL: (id: string) => TeamsSenderRoutes.ProviderEdit(id),
				getViewURL: (id: string) => TeamsSenderRoutes.ProviderView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.name, new StringFormatter(StringFormatterSizeType.FullName)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.azure_credential_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.token, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.type, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.e_verified, new ForeColorFormatter(new BooleanFormatter("Verified", "Not Yet"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.meta, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.limit, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.limit_count, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.limit_per_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.limit_per_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.delay, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.delay_value, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.delay_unit, new StringFormatter(StringFormatterSizeType.Word)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.provider.columns.updated_at, new DateTimeFormatter()),
					];
				},
				onCreate: async (entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.e_verified;
					delete body.meta;
					delete body.created_at
					delete body.updated_at;
					if (entity.type === ProviderType.Channel)
						return await props.servers.teams_sender.channel.Create(body);
					throw new Error("Wrong provider type");
				},
				onUpdate: async (id, entity) =>
				{
					let body = { ...entity, ...entity.meta };
					delete body.id;
					delete body.user_id;
					delete body.project_id;
					delete body.type;
					delete body.e_verified;
					delete body.meta;
					delete body.created_at
					delete body.updated_at;
					if (entity.type === ProviderType.Channel)
						return await props.servers.teams_sender.channel.Update(id, body);
					throw new Error("Wrong provider type");
				},
				getMenus: (getIDs, getRows) => { return { "Provider": [TeamsSenderMenus.verify(getIDs, getRows), TeamsSenderMenus.send(getIDs, getRows)] } },
				onSuccess: (entity) =>
				{
					props.url.redirect(TeamsSenderRoutes.Verify(entity.id), {});
					return true;
				}
			},
			server: {
				value_list: props.servers.teams_sender.value.List,
				get: props.servers.teams_sender.provider.Get,
				list: props.servers.teams_sender.provider.List,
				create: async (entity) =>
				{
					if (entity.type === ProviderType.Channel)
					{
						let body: ChannelCreateRow = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							azure_credential_id: entity.azure_credential_id,
							token: entity.token,
							team_id: entity.meta.team_id,
							channel_id: entity.meta.channel_id,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						};
						return await props.servers.teams_sender.channel.Create(body);
					}
					throw new Error("Wrong provider type");
				},
				update: async (id, entity) =>
				{
					if (entity.type === ProviderType.Channel)
					{
						let body: ChannelUpdateRow = {
							workspace_id: entity.workspace_id,
							name: entity.name,
							limit: entity.limit,
							limit_count: entity.limit_count,
							limit_per_value: entity.limit_per_value,
							limit_per_unit: entity.limit_per_unit,
							azure_credential_id: entity.azure_credential_id,
							token: entity.token,
							team_id: entity.meta.team_id,
							channel_id: entity.meta.channel_id,
							delay: entity.delay,
							delay_value: entity.delay_value,
							delay_unit: entity.delay_unit,
							description: entity.description,
							provider_category: [], provider_field: [], provider_tag: [],
						};
						return await props.servers.teams_sender.channel.Update(id, body);
					}
					throw new Error("Wrong provider type");
				},
				delete: props.servers.teams_sender.provider.Delete,
			}
		};
	}
	static sent(props: NSARouterMakerResult & TeamsSenderRouterProps): IEntityInfo<SentRow, SentRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_TEAMS_SENDER,
			name: "sent",
			tables: [{ table: namirasoft.teams_sender.tables.sent, required: true }],
			client: {
				getListURL: () => TeamsSenderRoutes.SentList,
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getViewURL: null,
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.session_id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.provider_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.team_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.channel_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.successful, new ForeColorFormatter(new BooleanFormatter("Successful", "Failed"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.result, new StringFormatter(StringFormatterSizeType.Sentence)),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.teams_sender.tables.sent.columns.sent_at, new DateTimeFormatter()),
					];
				}
			},
			server: {
				value_list: props.servers.teams_sender.value.List,
				get: props.servers.teams_sender.sent.Get,
				list: props.servers.teams_sender.sent.List,
				create: null,
				update: null,
				delete: null,
			}
		}
	}
}